module.exports = `${require.publicPath}banner-img.4621505b.jpg`;